import { Component, input } from '@angular/core';

@Component({
  selector: 'app-card-info-match',
  standalone: true,
  imports: [],
  templateUrl: 'card-info-match.component.html',
})
export class CardInfoMatchComponent {
  title = input.required<string>();
  image = input.required<string>();
}
